import React from 'react'
import { getClassSize, getClassColor } from './icon'

export default function IconArrowUp(props) {
  const { size, color, ...other } = props

  return (
    <svg className={getClassSize(size)} viewBox="0 0 24 24" {...other}>
      <path
        className={getClassColor(color)}
        d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
      />
    </svg>
  )
}
